export default __webpack_public_path__ + "static/media/image.the-papayas-tech.63a809a0.png";